import { createTheme, ThemeOptions, Shadows } from '@mui/material/styles';

// Create a temporary theme to get the default `shadows` object
const defaultTheme = createTheme();
const defaultShadows: ThemeOptions['shadows'] = [...defaultTheme.shadows];

// Disable shadows
export const shadows = defaultShadows.map(() => 'none') as Shadows;
